import React from 'react';
import PropTypes from 'prop-types';
import { Loc } from 'redux-react-i18n';
import { Link } from 'react-router-dom';
import Loader from 'components/mediabay-ui/components/Loader';
import Button from 'components/mediabay-ui/components/Button';
import AdFoxBanner from 'components/Ads/AdFoxBanner';
import Player from '../../Player/Player';
import {
  Container,
  Wrapper,
  // PlayButton,
  PlayerContainer,
  EpisodesContainer,
  EpisodeItem,
} from './styles';

class PlayerWrapper extends React.Component {
  static propTypes = {
    // Handlers
    selectHandler: PropTypes.func.isRequired,
    episodeClickHandler: PropTypes.func.isRequired,

    // Data
    currentLanguage: PropTypes.string.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
      state: PropTypes.object,
    }).isRequired,
    videoDetails: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.object,
    }).isRequired,
    videoEpisodes: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
    episodeThread: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.object,
    }).isRequired,
    episodeEndedHandler: PropTypes.func,
  }

  static defaultProps = {
    episodeEndedHandler: () => null,
  }

  constructor(props) {
    super(props);

    this.state = {
      isFetching: true,
      videoDetails: this.props.videoDetails,
      videoEpisodes: this.props.videoEpisodes,
      episodeThread: this.props.episodeThread,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.videoDetails.status !== null && nextProps.videoEpisodes.status !== null) {
      return {
        isFetching: false,
        videoDetails: nextProps.videoDetails,
        videoEpisodes: nextProps.videoEpisodes,
        episodeThread: nextProps.episodeThread,
      };
    }

    return null;
  }

  render() {
    let player = null;
    let playerNav = null;
    const { currentLanguage, episodeEndedHandler, hasVoucher } = this.props;
    const {
      isFetching,
      videoDetails,
      videoEpisodes,
      episodeThread,
    } = this.state;

    if (isFetching) {
      player = (
        <PlayerContainer>
          <Loader />
        </PlayerContainer>
      );
    } else if (
      videoDetails.status === 401 || episodeThread.status === 401) {
      player = (
        <PlayerContainer>
          <Link to={{ pathname: '/auth', state: { from: this.props.location } }}>
            <Button type="primary">
              <Loc locKey="authAction" />
            </Button>
          </Link>
        </PlayerContainer>
      );
    } else if (videoEpisodes.status === 402 || episodeThread.status === 402) {
      player = (
        <PlayerContainer style={{ flexDirection: 'column' }}>
          <h3>
            <Loc locKey="subscribeChannelInfo" />
          </h3>
          <div style={{ margin: '5px auto 15px' }}>
            {episodeThread.data.vouchers && episodeThread.data.vouchers.length > 0 ? (
              episodeThread.data.vouchers.map(v => (
                <p style={{ fontSize: 18, textAlign: 'center', margin: '0 auto 10px' }}>{v.title}</p>
              ))
            ) : null}
          </div>
          <div>
            <Link to={{ pathname: '/profile/services', state: { from: this.props.location } }}>
              <Button type="primary">
                <Loc locKey="subscribeAction" />
              </Button>
            </Link>
          </div>
        </PlayerContainer>
      );
    } else if (videoDetails.status === 200) {
      player = (
        <Wrapper>
          {
            episodeThread.status && (
              <Player
                autoplay
                episodeEndedHandler={episodeEndedHandler}
                hasVoucher={hasVoucher}
                sources={[{
                  id: episodeThread.data.media,
                  src: episodeThread.data.preview,
                  type: 'application/x-mpegURL',
                }]}
              />
            )
          }

          <AdFoxBanner slot={3} />
        </Wrapper>
      );

      if (videoDetails.data.seasons.length <= 1 && videoEpisodes.data.length <= 1) {
        playerNav = null;
      } else {
        playerNav = (
          <EpisodesContainer>
            <select
              onChange={this.props.selectHandler}
              value={this.state.seasonValue}
            >
              {
                videoDetails.data.seasons.map(season => (
                  <option
                    key={season.id}
                    value={season.id}
                  >
                    {season.name.ru}
                  </option>
                ))
              }
            </select>
            <div>
              {videoEpisodes.data.map(episode => (
                <EpisodeItem
                  key={episode.id}
                  data-id={episode.id}
                  onClick={this.props.episodeClickHandler}
                  isActive={episode.id === episodeThread.data.media}
                >
                  {episode.title[currentLanguage] || episode.title['ru']}
                </EpisodeItem>
              ))}
            </div>

          </EpisodesContainer>
        );
      }
    }

    return (
      <Container>
        {player}
        {playerNav}
      </Container>
    );
  }
}

export default PlayerWrapper;
